// Reduce y comprime la imagen en el navegador antes de subirla.
// Un logo se renderiza a ~80px; subir el original (varios MB) es innecesario y lento.
// Conserva el formato original (png mantiene transparencia) y, ante cualquier problema,
// devuelve el data URL original sin tocar -- asi nunca rompe la subida.
export const fileToResizedDataUrl = (
  file: File,
  maxSize = 256,
  quality = 0.85
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No pudimos leer la imagen."));
    reader.onload = () => {
      const original = String(reader.result || "");
      const image = new Image();
      image.onerror = () => resolve(original);
      image.onload = () => {
        try {
          const naturalW = image.naturalWidth || image.width;
          const naturalH = image.naturalHeight || image.height;
          const scale = Math.min(1, maxSize / Math.max(naturalW, naturalH));
          const width = Math.max(1, Math.round(naturalW * scale));
          const height = Math.max(1, Math.round(naturalH * scale));
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            resolve(original);
            return;
          }
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(image, 0, 0, width, height);
          const outputType = file.type && file.type.startsWith("image/") ? file.type : "image/png";
          const resized = canvas.toDataURL(outputType, quality);
          resolve(resized && resized.startsWith("data:image") ? resized : original);
        } catch {
          resolve(original);
        }
      };
      image.src = original;
    };
    reader.readAsDataURL(file);
  });
};

export const fileToPngDataUrl = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No pudimos leer la imagen."));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error("La imagen no se pudo procesar."));
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth || image.width;
        canvas.height = image.naturalHeight || image.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("No pudimos preparar la imagen."));
          return;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      image.src = String(reader.result || "");
    };
    reader.readAsDataURL(file);
  });
};
